export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-100px.049c6153.jpg";